import { render, staticRenderFns } from "./chanxian.vue?vue&type=template&id=8457aba8&scoped=true&"
import script from "./chanxian.vue?vue&type=script&lang=js&"
export * from "./chanxian.vue?vue&type=script&lang=js&"
import style0 from "./chanxian.vue?vue&type=style&index=0&id=8457aba8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8457aba8",
  null
  
)

export default component.exports